<template>
  <div class="upload">
    <Header :hasBack="goback">
    </Header>
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
      class="detail-tabs"
      style="flex: 1"
    >
      <el-tab-pane label="Barplot" name="first">
        <div class="upload-scroll">
          <div class="upload-body_c">
            <iframe
              name="loadiframe"
              id="iframe"
              :src="pathUrl_barplot"
              frameborder="0"
              width="100%"
              height="100%"
            ></iframe>
          </div>
          <Footer style="width: 1170px; margin: auto" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="Heatmap" name="second">
        <div class="upload-scroll">
          <div class="upload-body_c">
            <iframe
              name="loadiframe"
              id="iframe"
              :src="pathUrl_heatmap"
              frameborder="0"
              width="100%"
              height="100%"
            ></iframe>
          </div>
          <Footer style="width: 1170px; margin: auto" />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Header from './common/header.vue'
import Footer from './common/footer.vue'
export default {
  name: 'detail_qiime',
  props: {
    msg: String
  },
  components: { Footer, Header },
  data () {
    return {
      pathUrl_barplot: '',
      pathUrl_heatmap: '',
      goback: false,
      activeName: 'first'
    }
  },
  created () {
  },
  mounted () {
    let params = JSON.parse(decodeURIComponent(this.$route.query.key))
    console.log('this.$route.query.key: ', this.$route.query.key)
    let userid = params.userid
    let barplotid = params.barplotid || ''
    let heatmapid = params.heatmapid || ''
    console.log('userid: ', userid)
    console.log('barplotid: ', barplotid)
    console.log('heatmapid: ', heatmapid)
    if (barplotid !== '') {
      this.getBarplotData(barplotid)
    }
    if (heatmapid !== '') {
      this.getHeatmapData(heatmapid)
    }
  },
  methods: {
    getBarplotData (id) {
      this.pathUrl_barplot = this.globalUrl + '/out/' + id + '/data/index.html'
      console.log('pathUrl_barplot:', this.pathUrl_barplot)
    },
    getHeatmapData (id) {
      this.pathUrl_heatmap = this.globalUrl + '/out/' + id + '/data/index.html'
      console.log('pathUrl_heatmap:', this.pathUrl_heatmap)
    },
    handleClick (tab, event) {
      console.log(tab, event)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.upload {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.upload-scroll {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
.upload-body_c {
  flex: 1;
/*  max-width: 1170px;
*/
  margin: auto;
  width: 100%;
  min-height: 1px;
  text-align: left;
  min-height: 100px;
}
.detail-tabs {
  padding: 0 10px;
  box-sizing: border-box;
  margin-top: -10px;
}
.detail-tabs /deep/ .el-tabs__content {
  height: calc(100% - 60px);
}
.detail-tabs /deep/ .el-tabs__content .el-tab-pane {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/detail_qiime.vue